import { Injectable } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly headerPortal$ = new BehaviorSubject<CdkPortal | null>(null);
  readonly sidebarWidth$ = new BehaviorSubject<number>(252);

  setHeader(portal: CdkPortal | null): void {
    this.headerPortal$.next(portal);
  }

  setSidebarWidth(width: number): void {
    this.sidebarWidth$.next(width);
  }
}
